import React, { useEffect, useRef } from "react";
import { Html5Qrcode } from "html5-qrcode";
import Swal from "sweetalert2";

const ScannerAsistenciaQR = ({ onClose, idCurso, curso, Usuario, socket }) => {
  const scannerRef = useRef(null);
  const procesando = useRef(false);

  const detenerScanner = async () => {
    try {
      if (scannerRef.current) {
        const state = scannerRef.current.getState?.();

        if (state === 2) {
          await scannerRef.current.stop();
        }

        scannerRef.current.clear();
        scannerRef.current = null;
      }
    } catch (err) {
      console.warn("Error cerrando scanner", err);
    }
  };

  const registrarAsistencia = async (dni) => {
    try {
      const response = await fetch(
        "https://wwwa.isepsantafe.net.ar/expedientes/calificaciones/registrarAsistenciaManual",
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            alumnoDni: dni,
            cursoId: idCurso,
            token:
              "no requiere: Generacion Manual por Usuario " +
              Usuario.identificacion,
            escuela: curso.escuela,
            sede: curso.sede,
            operacion: "QR",
          }),
        }
      );

      const data = await response.json();

      if (data.ok) {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: `✔ DNI ${dni}`,
          showConfirmButton: false,
          timer: 1200,
        });

        socket.emit("DiPresente", { IdCurso: idCurso });
      } else {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "warning",
          title: data.message,
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (error) {
      console.error(error);

      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "Error al registrar",
        showConfirmButton: false,
        timer: 1500,
      });
    } finally {
      // 🔥 importante: permite seguir escaneando
      setTimeout(() => {
        procesando.current = false;
      }, 800);
    }
  };

  useEffect(() => {
    const scanner = new Html5Qrcode("qr-reader");
    scannerRef.current = scanner;

    const iniciar = async () => {
      try {
        await scanner.start(
          { facingMode: "environment" },
          { fps: 15, qrbox: 280 },
          async (decodedText) => {
            if (procesando.current) return;

            procesando.current = true;

            const dni = decodedText.trim();

            // opcional: validar que sea número
            if (!/^\d+$/.test(dni)) {
              Swal.fire({
                toast: true,
                position: "top-end",
                icon: "warning",
                title: "QR inválido",
                showConfirmButton: false,
                timer: 1000,
              });

              procesando.current = false;
              return;
            }

            await registrarAsistencia(dni);
          }
        );
      } catch (err) {
        console.error(err);

        Swal.fire({
          icon: "error",
          title: "Error cámara",
          text: "No se pudo acceder",
        });
      }
    };

    iniciar();

    return () => {
      detenerScanner();
    };
  }, []);

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "#000",
        zIndex: 9999,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* HEADER */}
      <div
        style={{
          height: 60,
          background: "#111",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 15px",
        }}
      >
        <span>Escanear QR - Asistencia</span>

        <button
          onClick={async () => {
            await detenerScanner();
            onClose?.();
          }}
          style={{
            background: "red",
            color: "#fff",
            border: "none",
            padding: "8px 12px",
            borderRadius: 6,
          }}
        >
          Cerrar
        </button>
      </div>

      {/* SCANNER */}
      <div
        id="qr-reader"
        style={{
          flex: 1,
          width: "100%",
        }}
      />
    </div>
  );
};

export default ScannerAsistenciaQR;